export default __webpack_public_path__ + "assets/icons/freightDelivery.d144014c.svg";